// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VehiclesUI_view__slpL6 {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.VehiclesUI_loader__r0sxE {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.VehiclesUI_edit__V8E2n,.VehiclesUI_password__RyeYm, .VehiclesUI_delete__xflWY {
  cursor: pointer;
  margin-top: 3px;
}

.VehiclesUI_actions__T0ISm {
  display: flex;
  align-items: center;
  justify-content: center;
}

.VehiclesUI_divider__eMR-J {
  width: 1px;
  background-color: #C9C9C9;
  height: 22px;
  margin: 0 15px;
}

.VehiclesUI_buttons__Oi6ov{
  display: flex;
  column-gap: 20px;
}


`, "",{"version":3,"sources":["webpack://./src/pages/vehicles/styles/VehiclesUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".view {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.edit,.password, .delete {\n  cursor: pointer;\n  margin-top: 3px;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.divider {\n  width: 1px;\n  background-color: #C9C9C9;\n  height: 22px;\n  margin: 0 15px;\n}\n\n.buttons{\n  display: flex;\n  column-gap: 20px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `VehiclesUI_view__slpL6`,
	"loader": `VehiclesUI_loader__r0sxE`,
	"edit": `VehiclesUI_edit__V8E2n`,
	"password": `VehiclesUI_password__RyeYm`,
	"delete": `VehiclesUI_delete__xflWY`,
	"actions": `VehiclesUI_actions__T0ISm`,
	"divider": `VehiclesUI_divider__eMR-J`,
	"buttons": `VehiclesUI_buttons__Oi6ov`
};
export default ___CSS_LOADER_EXPORT___;
